const styles = () => ({
  container: { backgroundColor: 'transparent' },
})

export default styles
